import { AxiosInstance } from "axios";
import { DefaultResponseI } from "shared/lib/interfaces/api";

export interface UpdateCallSettingsParamsI {
  call_forwarding_disabled?: boolean;
  phone_number?: string;
}

export interface GetDialerSettingsResponseI {
  call_cooldown_hours: number | null;
  record_based_on_state_two_party: boolean | null;
}

export const CallSettingsAPIEndpoints = (client: AxiosInstance) => ({
  update: (settings: UpdateCallSettingsParamsI) =>
    client.patch("/v1/settings", { settings }),

  fetchDialerSettings: () =>
    client.get<GetDialerSettingsResponseI>("/x/v1/dialer_settings"),

  setCooldownHours: (cooldownHours: number) =>
    client.patch<DefaultResponseI>("/x/v1/dialer_settings", {
      call_cooldown_hours: cooldownHours,
    }),

  setCallRecordingsTwoPartyConsent: (
    record_based_on_state_two_party: boolean
  ) =>
    client.patch<DefaultResponseI>("/x/v1/dialer_settings/state_two_party", {
      record_based_on_state_two_party,
    }),
});
